// CreateGroup.jsx
import React, { useState } from "react";
import backend from "../../../../../api";
import AppHeader from "../../../../../components/AppHeader";
import { useNavigate } from "react-router-dom";
import "./CreateGroup.css";
import { useSelector } from "react-redux";

export default function CreateGroup() {
  const nav = useNavigate();
  const { user } = useSelector(s => s.auth);
  const userId = user?._id;

  const [name, setName] = useState("");
  const [err, setErr] = useState("");

  const save = async () => {
    try {
      setErr("");
      const res = await backend.post("/groups", { name, adminId: userId });
      const g = res?.data?.data;
      nav(`/groups/${g._id}/edit`);
    } catch (e) {
      setErr(e?.response?.data?.message || "Create failed");
    }
  };

  return (
    <div className="cg-page">
      <AppHeader title="Create group" onBack={() => nav(-1)} />
      {err && <div className="cg-error">{err}</div>}
      <div className="cg-card">
        <label className="cg-label">Group name</label>
        <input className="cg-input" value={name} onChange={e=>setName(e.target.value)} placeholder="Create group name" />
        <button className="cg-save" onClick={save}>Save</button>
      </div>
    </div>
  );
}